import store from '../redux/store';
import { fetchUser } from '../redux/slicers/authenticationSlice';
import axios from 'axios';
import { fetchClients, fetchSites, selectClient, selectSite } from '../redux/slicers/tenancySlice';
import { User } from '../interfaces/user';
import { authenticationService } from '../redux/services/authentication.service';
import { fetchAreas, setAreaRooms } from '../redux/slicers/areaSlice';
import { fetchRooms, setRoomZones } from '../redux/slicers/roomSlice';
import { fetchZones } from '../redux/slicers/zoneSlice';
import { fetchDevicesCategory } from '../redux/slicers/devicesSlice';
import { Room } from '../interfaces/rooms';
import { Zone } from '../interfaces/zones';
import Cookies from 'js-cookie';
import { fetchReferenceRoles } from '../redux/slicers/referenceSlice';
import { rooms } from '../api/rooms';

export async function initializeUser(): Promise<User | undefined> {
	const token = Cookies.get('Global-Token');
	if (token) {
		const parsedToken = JSON.parse(token);
		axios.defaults.headers.common['Authorization'] = parsedToken.token;
		const userResult = await store.dispatch(fetchUser({ id: parsedToken.id }));
		return userResult.payload as User;
	}
	return undefined;
}

export async function initializeTenancy(): Promise<boolean> {
	try {
		await Promise.all([
			store.dispatch(fetchClients()),
			store.dispatch(fetchSites()),
			store.dispatch(fetchReferenceRoles()),
		]);
		return true;
	} catch (e) {
		return false;
	}
}

export async function initializeData(
	clientId: number,
	siteId: number,
	withToken: boolean
): Promise<boolean> {
	try {
		store.dispatch(selectClient(clientId));
		store.dispatch(selectSite(siteId));
		await authenticationService.siteSpecificAuthentication(clientId, siteId, withToken);
		const promiseLocations = await Promise.all([
			await store.dispatch(fetchAreas()),
			await store.dispatch(fetchRooms()),
			await store.dispatch(fetchZones()),
		]);
		await store.dispatch(setAreaRooms(promiseLocations[1].payload as Room[]));
		await store.dispatch(setRoomZones(promiseLocations[2].payload as Zone[]));
		await store.dispatch(fetchDevicesCategory('sensors'));
		return true;
	} catch (e) {
		return false;
	}
}

export async function QRInitialization(roomId: number, withToken: boolean): Promise<boolean> {
	try {
		const room = await rooms.getRoom(roomId);
		if (!room) {
			return false;
		}
		return await initializeData(room.fk_client, room.fk_site, withToken);
	} catch (e) {
		return false;
	}
}
